
const fields = {

    redni_broj: {
        key: 'redni_broj',
        type: 'hInput',
        templateOptions: {
            label: 'Redni broj'
        }
    },
    doktor: {
        key: 'doktor',
        type: 'hInput',
        templateOptions: {
            label: 'Doktor',
            required: true
        }
    },
    datum: {
        key: 'datum',
        type: 'hDatepicker',
        templateOptions: {
            label: 'Datum posjete',
            required: true
        }
    },
    djelatnost: {
        key: 'djelatnost',
        type: 'huiSelect',
        templateOptions: {
            label: 'Djelatnost',
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'id',
            labelProp: 'naziv',
            placeholder: 'Odaberite djelatnost',
            options: [],
            allowClear: false,
            onSelect:"onSelect($item, $model)"
        },
        controller: ['$scope', 'DjelatnostPoliklinike', 'WizardHandler', function ($scope, Model, WizardHandler) {
            Model.findAll().then(function (response) {
                $scope.to.options = response;
            });

            $scope.onSelect = function($item, $model) {
                WizardHandler.wizard().next();
            };
        }],
    },
    vrstaPosjete: {
        key: 'vrsta_posjete',
        type: 'huiSelect',
        templateOptions: {
            label: 'Vrsta posjete',
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'id',
            labelProp: 'naziv',
            placeholder: 'Odaberite vrstu posjete',
            options: [],
            allowClear: false,
            onSelect:"onSelect($item, $model)",
            required: true
        },
        controller: ['$scope', 'VrstaPosjete', 'WizardHandler', function ($scope, Model, WizardHandler) {
            Model.findAll().then(function (response) {
                $scope.to.options = response;
            });

            $scope.onSelect = function($item, $model) {
                WizardHandler.wizard().next();
            };
        }],
    },
    dijagnoza: {
        key: 'dijagnoza',
        type: 'dijagnoza',
        templateOptions: {
            label: 'Šifra dijagnoze',
        },
    },

    dijagnoza_text: {
        key: 'dijagnoza_text',
        type: 'hTextarea',
        templateOptions : {
            label: 'Dijagnoza',
            rows: 3,
            required: true
        }
    },

    pacijent: {
        key: 'pacijent',
        type: 'huiSelect',
        templateOptions: {
            label: 'Pacijent',
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'id',
            labelProp: 'naziv',
            placeholder: 'Odaberite pacijenta',
            options: [],
            disabled: true
        },
        controller: ['$scope', 'Pacijent', function ($scope, Model) {
            Model.findAll().then(function (response) {
                $scope.to.options = response;
            });
        }],
    },
    napomena: {
        key: 'napomena',
        type: 'textarea',
        templateOptions: {
            // label: 'Napomena'
            rows: 20,
            cols: 50
        }
    },

    djelatnik : {
        key: 'djelatnik',
        type: 'huiSelect',
        templateOptions: {
            label: 'Djelatnik',
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'id',
            labelProp: 'naziv',
            placeholder: 'Odaberite djelatnika',
            options: []
        },
        controller: ['$scope', 'Djelatnik', function ($scope, Model) {
            Model.findAll().then(function (response) {
                $scope.to.options = response;
            });
        }]
    },

    anamesis_fam: {
        key: 'anamesis_fam',
        type: 'hTextarea',
        templateOptions: {
            label: 'Anamesis fam',
            rows: 5,
            cols: 50
        }
    },

    anamesis_vitae: {
        key: 'anamesis_vitae',
        type: 'hTextarea',
        templateOptions: {
            label: 'Anamesis vitae',
            rows: 5,
            cols: 50
        }
    },

    anamesis_gyn: {
        key: 'anamesis_gyn',
        type: 'hTextarea',
        templateOptions: {
            label: 'Anamesis gyn',
            rows: 5,
            cols: 50
        }
    },

     hormonski_pripravci_iucd: {
        key: 'hormonski_pripravci_iucd',
        type: 'hInput',
        templateOptions: {
            label: 'Hormonski pripravci/IUCD',
        }
    },

    ginekoloske_operacije: {
        key: 'ginekoloske_operacije',
        type: 'hInput',
        templateOptions: {
            label: 'Ginekološke operacije',
        }
    },

    ostalo: {
        key: 'ostalo',
        type: 'hInput',
        templateOptions: {
            label: 'Ostalo',
        }
    },

    zm: {
        key: 'zm',
        type: 'hInput',
        templateOptions: {
            label: 'ZM',
        }
    },

    prethodna_gin_operacija_prije: {
        key: 'prethodna_gin_operacija_prije',
        type: 'hInput',
        templateOptions: {
            label: 'Prethodna ginekološka operacija prije',
        }
    },

    sadasnje_tegobe: {
        key: 'sadasnje_tegobe',
        type: 'hTextarea',
        templateOptions: {
            label: 'Sadašnje tegobe',
            rows: 5,
            cols: 50
        }
    },

    klinicki_pregled: {
        key: 'klinicki_pregled',
        type: 'hTextarea',
        templateOptions: {
            label: 'Klinički pregled',
            rows: 5,
            cols: 50
        }
    },

    papa: {
        key: 'papa',
        type: 'hInput',
        templateOptions: {
            label: 'PAPA',
        }
    },

    uz_vs_cd: {
        key: 'uz_vs_cd',
        type: 'hInput',
        templateOptions: {
            label: 'UZ VS/CD',
        }
    },

    dodatne_pretrage: {
        key: 'dodatne_pretrage',
        type: 'hTextarea',
        templateOptions: {
            label: 'Dodatne pretrage',
            rows: 5,
            cols: 50
        }
    },

    komentari_preporuka: {
        key: 'komentari_preporuka',
        type: 'hTextarea',
        templateOptions: {
            label: 'Komentari/preporuka',
            rows: 5,
            cols: 50
        }
    },

     napomena_gyn: {
        key: 'napomena',
        type: 'hTextarea',
        templateOptions: {
            label: 'Napomena',
            rows: 5,
            cols: 50
        }
    },


};

export {fields};



// WEBPACK FOOTER //
// ./app/components/pregled/form/fields.js